const initialState = {
    favoriteCharacters: []
};

const favoriteReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_FAVORITE_CHARACTERS":
            let newState = {
            ...state,
            favoriteCharacters: state.favoriteCharacters.concat(action.character)
            };
            return newState;
      default:
        return state;
    }
};

export default favoriteReducer;
